import React from 'react';
import WheelplaceFooter from './WheelplaceFooter';

const FooterComponent = () => <WheelplaceFooter />;

export default FooterComponent;
